import {SlickSlider as Slider} from "./src/components/SlickSlider";

export type {SliderType} from "./src/components/SlickSlider";

export default Slider;
import {SlickSlider as Slider} from "./src/components/SlickSlider";

export type {SliderType} from "./src/components/SlickSlider";

export default Slider;
